/*
 *
 * DrawersPanel reducer
 *
 */

import ActionTypes from './constants';
import { ContainerActions, ContainerState } from './types';
import ActionTypesSelection from './../Configurator/constants/selection';

export const initialState: ContainerState = {
  isVisible: false,
  drawersSelected: [],
};

function drawersPanelReducer(
  state: ContainerState = initialState,
  action: any,
): ContainerState {
  switch (action.type) {
    case ActionTypes.DISPLAY_DRAWERS_PANEL:
      return { ...state, isVisible: action.payload.value };
    case ActionTypes.SELECTION_DRAWERS:
      return { ...state, drawersSelected: action.payload.values };
    // case ActionTypesSelection.SHELVES_SELECTION:
    //   if (state.drawersSelected === 'All' && state.isVisible === true) {
    //     if (action.payload.value.length === 1) {
    //       return { ...state, drawersSelected: [0] };
    //     }
    //   }
    //   return { ...state };
    default:
      return state;
  }
}

export default drawersPanelReducer;
